import {
  useReactFlow,
  getRectOfNodes,
  getTransformForBounds,
} from 'react-flow-renderer';
import { toPng } from 'html-to-image';

function downloadImage(dataUrl: any) {
  const a = document.createElement('a');

  a.setAttribute('download', 'reactflow.png');
  a.setAttribute('href', dataUrl);
  a.click();
}

const imageWidth = 1924;
const imageHeight = 1068;

function Download(getNodes: any) {
  alert();
  // we calculate a transform for the nodes so that all nodes are visible
  // we then overwrite the transform of the `.react-flow__viewport` element
  // with the style option of the html-to-image library
  const nodesBounds = getRectOfNodes(getNodes());
  const transform = getTransformForBounds(
    nodesBounds,
    imageWidth,
    imageHeight,
    0.1,
    2,
  );

  toPng(document.querySelector('.react-flow__viewport') as HTMLElement, {
    backgroundColor: '#ffffff',
    width: imageWidth,
    height: imageHeight,
    style: {
      width: imageWidth.toString(),
      height: imageHeight.toString(),
      transform: `translate(${transform[0]}px, ${transform[1]}px) scale(${transform[2]})`,
    },
  }).then(downloadImage);
}

export default Download;
